import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { getErrorMessage } from "../functions";

type InputProps = {
    id?: string;
    // invalid?: boolean | null;
    error?: any;
    label?: string;
    type?: string;
    name?: string;
    placeholder?: string;
    disabled?: boolean | null;
    value?: string | null;
    autoComplete?: string;
    className?: string;
    onChange?: any;
};

type SelectProps = InputProps & {
    options: Array<any>;
}

const StyledSelect = styled.select<InputProps>`
  ${tw`mt-1 block w-full pl-3 pr-6 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`}
  ${tw`max-w-full border font-semibold text-gray-600 `}
  ${(props) => props.error ? tw`border-red-500` : ``}
  option{
    ${tw`font-semibold text-gray-600`}
  }
`;


const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({ error, label, options, ...rest }: SelectProps, ref) => {
    return (
        <div className={`mb-4`}>
            {label && (<label className={`block text-sm font-medium text-gray-700`}>{label}</label>)}
            <StyledSelect
                ref={ref}
                {...rest}
            >
                {options.length > 0 ?
                    options.map((v, i) => {
                        return (<option key={v.value} value={v.value}>{v.label}</option>)
                    })
                    : <option>No Options present?</option>}
            </StyledSelect>
            {error && (
                <div className={`flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1`}>{getErrorMessage(error)}</div>
            )}
        </div>
    )
});

export default Select;